<template>
  <div class="profile">
    <h4 class="is-size-4">
      {{ profile.name }}
      <span v-if="profile.admin">(admin)</span>
    </h4>
    <div class="is-size-7">
      <em>{{ profile.family }} family</em>
    </div>
    <br>
    <h5 class="is-size-5">Preferences</h5>
    <div class="content">
      <ul>
        <li>
          <em>Color: </em>
          <strong>
            <span>{{ profile.prefs.color }}</span>
          </strong>&nbsp;
          <color-swatch :color="profile.prefs.color.replace(' ', '').toLowerCase()" />
        </li>
        <li>
          <em>Shoe Size: </em>
          <strong>
            <span>{{ profile.prefs['shoe-size'] }}</span>
          </strong>
        </li>
        <li>
          <em>Shirt Size: </em>
          <strong>
            <span>{{ profile.prefs['shirt-size'] }}</span>
          </strong>
        </li>
      </ul>
    </div>
    <h5 class="is-size-5">Interests</h5>
    <div class="content">
      <ul>
        <li
          v-for="(int, i) in profile.prefs.interests"
          :key="i">
          {{ int }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ColorSwatch from '@/components/ColorSwatch'

export default {
  name: 'Profile',
  components: {
    ColorSwatch
  },
  props: {
    profile: {
      type: Object,
      validator (val) {
        return val.name && val.id
      },
      required: true
    }
  }
}
</script>
